import { useQuery } from "@tanstack/react-query";
import { Entry } from "../../entry/models/Entry";
import { getEntriesReport } from "../repository/LogbookRepository";

type UseEntriesReportProps = {
	startShiftId: number | null;
	endShiftId: number | null;
	assetId: number | null;
	searchText?: string | null;
	isAllPeriod?: boolean;
};

export const useEntriesReport = ({
	startShiftId,
	endShiftId,
	assetId,
	searchText,
	isAllPeriod,
}: UseEntriesReportProps) => {
	const trimmedSearch = searchText?.trim() || null;

	return useQuery<Entry[], Error>({
		queryKey: [
			"entriesReport",
			startShiftId,
			endShiftId,
			assetId,
			trimmedSearch,
			isAllPeriod,
		],
		queryFn: ({ signal }) =>
			getEntriesReport(
				{ startShiftId, endShiftId, assetId, searchText: trimmedSearch },
				signal,
			),
		enabled: isAllPeriod ? !!trimmedSearch : !!startShiftId && !!endShiftId,
	});
};

export const routeLogbookReport = "/logbook/report";
